const ServicesName = ({ row }) => {
  return (
    <div>
      {row.services?.map((service, index) => (
        <div style={{ paddingBottom: "10px", width: "120px" }} key={index}>
          {service?.name}
        </div>
      ))}
    </div>
  );
};

export default ServicesName;
